export enum ErrorPositions {
  right = "right",
  left = "left",
  bottom = "bottom",
  top = "top",
}

export type ErrorPosition = "right" | "bottom" | "top" | "left";
